import Skeleton from 'react-loading-skeleton';

import { brandColors } from '@/app/constants';

const AudienceLoader = () => {
  return (
    <div className="space-y-6">
      {/* Overview metrics skeleton */}
      <div className="grid grid-cols-4 gap-4">
        <Skeleton height={126} baseColor={brandColors.lightSilver} />
        <Skeleton height={126} baseColor={brandColors.lightSilver} />
        <Skeleton height={126} baseColor={brandColors.lightSilver} />
        <Skeleton height={126} baseColor={brandColors.lightSilver} />
      </div>

      {/* Charts section skeleton */}
      <div className="grid grid-cols-3 gap-4">
        {/* Top Churn Factors */}
        <Skeleton height={200} baseColor={brandColors.lightSilver} />

        {/* Retention Trend */}
        <div className="col-span-2">
          <Skeleton height={200} baseColor={brandColors.lightSilver} />
        </div>
      </div>

      {/* User Segments and additional charts */}
      <div className="grid grid-cols-2 gap-4">
        <Skeleton height={200} baseColor={brandColors.lightSilver} />
        <Skeleton height={200} baseColor={brandColors.lightSilver} />
      </div>

      {/* Table skeleton */}
      <div className="space-y-2">
        <Skeleton height={40} baseColor={brandColors.lightSilver} />
        <Skeleton height={40} baseColor={brandColors.lightSilver} />
        <Skeleton height={40} baseColor={brandColors.lightSilver} />
        <Skeleton height={40} baseColor={brandColors.lightSilver} />
        <Skeleton height={40} baseColor={brandColors.lightSilver} />
        <Skeleton height={40} baseColor={brandColors.lightSilver} />
      </div>
    </div>
  );
};

export default AudienceLoader;
